import { createContext, use } from 'react';

interface WidgetFormContextValue {
  compact: boolean;
}

const WidgetFormContext = createContext<WidgetFormContextValue>({ compact: false });

const WidgetFormProvider = WidgetFormContext.Provider;

const useWidgetFormContext = () => use(WidgetFormContext);

export { WidgetFormProvider, useWidgetFormContext, WidgetFormContext };
export type { WidgetFormContextValue };
